import type {AddServiceNoteFormPayload} from "./add-service-note.schema";

import {addServiceNote} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {serviceKeys, serviceMutationKeys} from "../../../../../service-keys";

export function addServiceNoteMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: serviceMutationKeys.addServiceNote,
    mutationFn: (payload: AddServiceNoteFormPayload) => addServiceNote(id, payload),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: serviceKeys.detail(id)}),
        client.invalidateQueries({queryKey: serviceKeys.lists()}),
      ]);
    },
  });
}
